import { makeStyles } from "@material-ui/core";
import { colors } from "../../../constants/colors/Colors";

export const useStyles = makeStyles(theme => ({


    root: {
        marginTop: 40,
        flexGrow: 1,
        borderRadius: 12,
        border: '1px solid #D4DDE4',
        width: '100%',
        paddingBottom:"30px"
    },
    appBar: {
        borderRadius: '12px 12px 0 0',
        backgroundColor: '#E6EDF3',
        height: 82,
        justifyContent: 'center',
        padding: '0px 20px',

    },
    selected: {
        width: 'auto',
        paddingLeft: 10,
        paddingRight: 10,
        height: 42,
        background: 'linear-gradient(#824ED2, #B07DFF)',
        borderRadius: 6,
        marginRight: 55,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    },
    notSelected: {
        width: 'auto',
        paddingLeft: 10,
        paddingRight: 10,
        height: 42,
        borderRadius: 6,
        marginRight: 55,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    },
    tabHead: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#091E42',
        fontFamily: 'Roboto-SemiBold',
    },
    activeTab: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#FFFFFF',
        fontFamily: 'Roboto-SemiBold',
    },
    tabsBodyContainer: {
        paddingLeft: 30,
        paddingRight: 30,
        width: '100%'
    },
    tableTitleRow: {
        display: 'inline-flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        marginTop: 10,
    },

    tableTitle: {
        color: colors.titleColor,
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '400',
    },

    titleForAll: {
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '400',
        color: colors.primary,
    },
}))